import { Link } from 'react-router';

import { EmptyState } from '@/components/stateViews';
import { Button } from '@/components/ui/button';

export const NotFoundPage = () => (
  <EmptyState title="Page not found">
    <Button asChild variant="secondary">
      <Link to="/">Back to overview</Link>
    </Button>
  </EmptyState>
);
